const statementTableDictPT = {
  financial: "Financeiro",
  extracredit: "Extracredit",
  wallet: "Carteira",
  walletStatement: "Extrato da carteira",
  extracoinStatement: "Extrato de Extracredit",
  extrabonusStatement: "Extrato Bonus Ads",
  bonusStatement: "Extrato da renda diária vitalícia",
  planNotAllowed: "Sua assinatura atual não tem acesso a este recurso.",
  statementSubtitle: "Acompanhe as operações realizadas na sua carteira usando Extracredit.",
  showingFirstToLast: "Mostrando {first} a {last} de {totalRecords}",
  noOperationsRecords: "Ainda não há registros de operações.",
  date: "Data",
  from: "De",
  toFrom: "Até",
  check: "Ver",
  statement: "Extrato",
  description: "Descrição",
  inbound: "Crédito",
  outbound: "Débito",
  status: "Status",
  dateTransaction: "Data da Transação",
  emptyDates: "Por favor escolha um período de duas datas.",
  completed: "Completa",
  pending: "Pendente",
  pendingVoucher: "Voucher pendente",
  canceled: "Cancelada",
};

export default statementTableDictPT;
